import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'

// import actions
import { getQualityCheckSettingsList, getQualityCheckSettings, updateQualityCheckSettings } from '../../actions/qualitychecksettings'

// import styles
import './qualitychecksettings.scss'

// import components
import Header from '../../shared/components/Header'
// import LeftMenu from '../../shared/components/Menus/LeftMenu'
import LeftMenuContent from '../../shared/components/Menus/LeftMenu/Content'

// Elements
import SideMenu from '../../shared/elements/sideMenu'
import SideMenuItem from '../../shared/elements/sideMenuItem'

// Utils
import { hasAccess } from '../../utils/auth'
import { translation, enumtranslate } from '../../utils/helpers'
import Button from '../../shared/elements/button'

class QualityCheckSettings extends Component {
  constructor (props) {
    super(props)
    this.state = {
      list: [
        {
          QualityCheckModelId: 0,
          Name: '',
          QualityCheckOrderType: 0,
          Active: true
        }
      ],
      activeItem: {
        QualityCheckModelId: 0,
        ChainId: 0,
        ShopId: 0,
        Name: '',
        QualityCheckTasks: [],
        QualityCheckBrands: [],
        QualityCheckCustomers: []
      },
      includeInactive: true,
      search: ''
    }
    this.renderChildren = this.renderChildren.bind(this)
    this.renderHeaderTitle = this.renderHeaderTitle.bind(this)
    this.headerButtonsRight = this.headerButtonsRight.bind(this)
    this.updateList = this.updateList.bind(this)
    this.createNew = this.createNew.bind(this)
    // this.filterList = this.filterList.bind(this)
    // this.searchList = this.searchList.bind(this)
    this.updateQualityCheckSettings = this.updateQualityCheckSettings.bind(this)
  }

  componentDidMount () {
    // if (!this.hasAccessToPage()) {
    //   this.props.router.push('/qualitychecksettings')
    // } else {
    this.updateList()
    // }
  }

  updateList () {
    // console.log('updateList')
    let chainId = this.props.auth.user.ChainId
    let shopId = this.props.auth.user.ShopId
    return this.props.getQualityCheckSettingsList(chainId, shopId).then((res) => {
      // console.log('res', res.data)
      this.setState({
        list: res.data,
        fetched: true
      })
      // console.log('Received: ', res.data)
      return res
    }, () => {
      console.log('Err fetching quality check settings lists data')
      return null
    })
  }

  renderHeaderTitle () {
    return (translation('1810'))
  }

  headerButtonsRight () {
    if (!hasAccess([3, 7], this.props.auth.user.UserType)) return null
    return (
      <div>
        <Button spacing={0} size='m' ariaText={translation('2053')} labelText={translation(1797)} onClick={this.createNew} />
      </div>
    )
  }

  createNew () {
    let create = {
      QualityCheckModelId: 0,
      QualityCheckOrderType: 1,
      BrandSelectionType: 0,
      Name: 'New'
    }
    this.updateQualityCheckSettings(create).then((res) => {
      let newId = res.data.QualityCheckModelId
      this.updateList().then((res) => {
        this.props.router.push('/qualitychecksettings/' + newId)
      })
    })
  }

  updateQualityCheckSettings (data) {
    return this.props.updateQualityCheckSettings(data)
  }

  // searchList (e) {
  //   if (e.target.name === 'SearchText') {
  //     this.setState({
  //       search: e.target.value
  //     })
  //   }
  //   if (e.target.name === 'Inactive') {
  //     this.setState({
  //       includeInactive: e.target.checked
  //     })
  //   }
  // }

  // filterList (item) {
  //   // console.log('item', item)
  //   if (item.Name === null) return true
  //   if (item === null || item.Active === undefined) return false
  //   if (item.Name.toLowerCase().indexOf(this.state.search.toLowerCase()) > -1 && (!this.state.includeInactive ? item.Active : true)) {
  //     return true
  //   }
  //   return false
  // }

  leftMenu () {
    if (this.state.list.length === 0) return null

    const renderItem = (val, key) => {
      let name = val.Name
      let link = '/qualitychecksettings/' + val.QualityCheckModelId
      let orderType = val.QualityCheckOrderType
      let isTitle = false

      if (name === null) {
        name = translation(enumtranslate('QualityCheckModelTypes', orderType, true))
        isTitle = true
      }

      return (
        <SideMenuItem
          label={name}
          renderLabel={(label, className, activeClassName) => (
            <Link to={link} className={className} activeClassName={activeClassName}>
              {label}
            </Link>
          )}
          inactive={!val.Active}
          isTitle={isTitle}
          key={key}
        />
      )
    }

    return this.state.list.map(renderItem)
  }

  renderChildren () {
    let child = ''
    if (this.props.children !== null) {
      child = React.cloneElement(this.props.children, {
        updateList: this.updateList,
        updateQualityCheckSettings: this.updateQualityCheckSettings
      })
    }
    return child
  }

  render () {
    return (
      <div className='qualitycheck__screen'>
        <Header router={this.props.router} renderRight={this.headerButtonsRight} />

        <SideMenu defaultShowInactive>
          {this.leftMenu()}
        </SideMenu>

        <LeftMenuContent className='qualitycheck__screen--inner'>
          {this.renderChildren()}
        </LeftMenuContent>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  getQualityCheckSettingsList,
  getQualityCheckSettings,
  updateQualityCheckSettings
})(QualityCheckSettings)



// WEBPACK FOOTER //
// ./src/app/pages/QualityCheckSettings/index.js